import { ZfDivider, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeleteSurplusItem } from '../../../api';
import type { PanelSettingsDto, SurplusItemSettingsDto, SurplusPanelSettingsDto } from '../../../api/generated/client';
import { SurplusForm } from './SurplusForm';
import { SurplusTable } from './SurplusTable';

interface IProps {
    cashflowOverrideSettings: SurplusPanelSettingsDto;
}

export const SurplusModalContent: FunctionComponent<IProps> = ({ cashflowOverrideSettings }) => {
    const { t } = useTranslation();
    const [surplusItem, setSurplusItem] = useState<SurplusItemSettingsDto | undefined>(undefined);
    const deleteSurplusItem = useDeleteSurplusItem();

    const cancel = () => setSurplusItem(undefined);

    const deleteItem = useCallback(
        (surplusItemId?: number) => {
            if (surplusItemId) {
                deleteSurplusItem.mutate(surplusItemId);
                cancel();
            }
        },
        [deleteSurplusItem],
    );

    return (
        <>
            <SurplusForm
                surplusItem={surplusItem}
                cashflowOverrideSettings={cashflowOverrideSettings as PanelSettingsDto}
                cancel={cancel}
                deleteItem={deleteItem}
            />
            <ZfDivider />
            <ZfTypography variant="body-medium" color="emphasis">
                {t('incomeExpenseSurplus')}
            </ZfTypography>
            <div className="surplus-table-wrapper">
                <SurplusTable surplusItems={cashflowOverrideSettings.itemsSettings!} editItem={setSurplusItem} deleteItem={deleteItem} />
            </div>
        </>
    );
};
